module.exports = __webpack_public_path__ + "img/com.codeway.cleanerplus-staging.c4a40555.png";